import { useStore } from "../designer/Store/zustandStore";
import { useConfigurationFan } from "../../hooks/useQueries";
export default function Drawings() {
  const [drawings, frames] = useStore((state) => [state.drawings, state.frames]);
  const [selectedUUID] = useStore((state) => [state.selectedUUID]);
  const fanFrame = frames?.find((f) => f.fan);
  const { fans } = useConfigurationFan(fanFrame ? [fanFrame.id] : selectedUUID);
  const selectedFanId = fans?.SelectedFanId ?? fans?.fan?.modelName ?? fans?.fan?.name ?? "";

  const fanName = fans?.fan?.modelName ?? fans?.fan?.name ?? fans?.SelectedFanId ?? "";
  const isExternalFan = fanFrame?.fan?.isExternal ?? false;
  const rightViewLabel = isExternalFan ? `${fanName} Front View` : "Unit Front View";

  return (
    <div className="p-5">
      {drawings?.length > 0 && (
        <>
          <h4>Side view</h4>
          <hr />
<div style={{ width: "100%" }}>
  <img
    src={drawings[0].side}
    alt="side view"
    style={{
      width: "100%",
      height: "auto",
      maxHeight: "1000px",   // limits height
      objectFit: "contain"  // optional
    }}
  />
</div>

          <h4 className="mt-4">Top view</h4>
          <hr />

          <div style={{ width: "100%" }}>
            <img
              src={drawings[0].top}
              alt="top view"
              style={{
                width: "100%",
                height: "auto",
                objectFit: "contain",
                objectPosition: "top",
                maxHeight:"1000px"
              }}
            />
          </div>
                    <h4 className="mt-4">Back View</h4>
          <hr />
          <div style={{ width: "100%" }}>
            <img
              src={drawings[0].left}
              alt="back view"
              style={{
                width: "100%",
                height: "auto",
                objectFit: "contain",
                objectPosition: "top",
                maxHeight:"1000px"
              }}
            />
          </div>
                    <h4 className="mt-4">{rightViewLabel}</h4>
          <hr />
          <div style={{ width: "100%" }}>
            <img
              src={drawings[0].right}
              alt={rightViewLabel.toLowerCase()}
              style={{
                width: "100%",
                height: "auto",
                objectFit: "contain",
                objectPosition: "top",
                maxHeight:"1000px"
              }}
            />
          </div>
          {/* <h4 className="mt-4">Combined view</h4>
          <hr /> */}

          {/* <div style={{ width: "100%" }}>
            <img
              src={drawings[0].combined}
              alt="top view"
              style={{
                width: "100%",
                height: "auto",
                objectFit: "contain",
                objectPosition: "top",
                maxHeight:"1000px"
              }}
            />
          </div> */}
        </>
      )}
    </div>
  );
}